<template>
    <b-card no-body>
        <b-modal id="modal-content" :title="editing ? 'İçerik Güncelle' : 'Yeni İçerik Ekle'" size="xl" no-close-on-backdrop scrollable>
            <content-form v-if="modalVisible" v-model="editedItem" :errors="errors" :languages="languages" :navigations="navigations" :parent-contents="parentContents" />
            <template #modal-footer>
                <v-executer :loading="loading" :action="save" :text="editing ? 'Güncelle' : 'Oluştur'" />
            </template>
        </b-modal>
        <b-modal id="modal-content-preview" title="İçerik Önizleme" size="lg" scrollable ok-only ok-title="Kapat">
            <content-preview :content="previewItem" :language="filter.LanguageCode || 'tr'" />
        </b-modal>

        <v-table ref="table" :fields="fields" :items-provider="provider" :add-callback="createNew" :buttons="buttons" pagination="client" search :with-items="false">
            <template #filters>
                <div class="row">
                    <div class="col-md-3">
                        <label>Navigasyon</label>
                        <v-select-list
                            v-model="filter.NavigationId"
                            :options="navigations"
                            label="Title"
                            :reduce="(nav) => nav.Id"
                            placeholder="Tüm Navigasyonlar"
                            :disabled="navigationsLoading"
                            :loading="navigationsLoading"
                            @input="$refs.table.refresh()"
                        />
                    </div>
                    <div class="col-md-3">
                        <label>Dil</label>
                        <v-select-list
                            v-model="filter.LanguageCode"
                            :options="languages"
                            label="LanguageName"
                            :reduce="(lang) => lang.LanguageCode"
                            placeholder="Tüm Diller"
                            :disabled="languagesLoading"
                            :loading="languagesLoading"
                            @input="$refs.table.refresh()"
                        />
                    </div>
                    <div class="col-md-3">
                        <label>Durum</label>
                        <v-select-list
                            v-model="filter.IsActive"
                            :options="[
                                { value: true, text: 'Aktif' },
                                { value: false, text: 'Pasif' },
                            ]"
                            label="text"
                            :reduce="(item) => item.value"
                            placeholder="Tümü"
                            @input="$refs.table.refresh()"
                        />
                    </div>
                    <div class="col-md-3">
                        <label>Öne Çıkan</label>
                        <v-select-list
                            v-model="filter.IsFeatured"
                            :options="[
                                { value: true, text: 'Evet' },
                                { value: false, text: 'Hayır' },
                            ]"
                            label="text"
                            :reduce="(item) => item.value"
                            placeholder="Tümü"
                            @input="$refs.table.refresh()"
                        />
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import WebsiteApi from "@/api/website";
import ContentForm from "./components/ContentForm.vue";
import VTable from "@/components/VTable.vue";
import VSelectList from "@/components/VSelectList.vue";
import VExecuter from "@/components/VExecuter.vue";
import ContentPreview from "./modals/ContentPreview.vue";

export default {
    name: "ContentManagement",
    components: {
        BCard,
        ContentForm,
        VTable,
        VSelectList,
        VExecuter,
        ContentPreview,
    },
    data() {
        return {
            loading: false,
            editing: false,
            modalVisible: false,
            errors: {},
            languages: [],
            navigations: [],
            parentContents: [],
            parentContentsLoaded: false,
            languagesLoading: false,
            navigationsLoading: false,
            previewItem: null,
            filter: {
                NavigationId: null,
                LanguageCode: "tr",
                IsActive: null,
                IsFeatured: null,
            },
            fields: [
                { name: "Content Key", key: "ContentKey", sortable: false, tdClass: "text-nowrap" },
                { name: "Slug", key: "Slug", sortable: false, tdClass: "text-nowrap" },
                {
                    name: "Başlık (Dil)",
                    key: "Translations",
                    sortable: false,
                    component: true,
                    componentOptions: { name: "website/TranslationSummaryBadge" },
                },
                {
                    name: "Durum",
                    key: "IsActive",
                    sortable: false,
                    tdClass: "text-center text-nowrap",
                    component: true,
                    componentOptions: { name: "website/StatusBadge" },
                },
                {
                    name: "Öne Çıkan",
                    key: "IsFeatured",
                    sortable: false,
                    tdClass: "text-center text-nowrap",
                    component: true,
                    componentOptions: { name: "website/FeaturedBadge" },
                },
                {
                    name: "Görüntülenme",
                    key: "ViewCount",
                    sortable: false,
                    tdClass: "text-center text-nowrap",
                    component: true,
                    componentOptions: { name: "website/ViewCountBadge" },
                },
                { name: "Sıra", key: "SortOrder", sortable: false, tdClass: "text-center", thClass: "text-nowrap" },
            ],
            buttons: [
                { text: "Önizle", key: "preview", icon: "EyeIcon", variant: "info", action: this.showPreview },
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteItem },
            ],
            editedItem: {
                id: null,
                navigationIds: [],
                parentContentId: null,
                contentKey: "",
                slug: "",
                isActive: true,
                isFeatured: false,
                publishDate: null,
                sortOrder: 0,
                translations: [],
                metaData: [],
                mediaFiles: [],
            },
        };
    },
    created() {
        this.loadFilterData();
        this.loadParentContents();
        this.$root.$on("bv::modal::hidden", this.onModalHidden);
    },
    beforeDestroy() {
        this.$root.$off("bv::modal::hidden", this.onModalHidden);
    },
    methods: {
        provider(options) {
            const payload = {
                NavigationId: this.filter.NavigationId,
                LanguageCode: this.filter.LanguageCode,
                IsActive: this.filter.IsActive,
                IsFeatured: this.filter.IsFeatured,
                // Skip: options.Skip,
                Skip: 0,
                Take: options.Take,
                QueryParam: options.QueryParam,
                IsAscending: options.IsAscending,
                OrderColumnName: options.OrderColumnName,
                IncludeTranslations: true,
                IncludeMetaData: true,
                IncludeMedia: true,
                IncludeChildren: false,
            };
            return WebsiteApi.Content.GetContents(payload);
            // .then((response) => {
            //     if (response.data.Success && Array.isArray(response.data.Data)) {
            //         return {
            //             data: {
            //                 Success: true,
            //                 Data: {
            //                     Data: response.data.Data,
            //                     TotalCount: response.data.TotalCount || response.data.Data.length,
            //                 },
            //             },
            //         };
            //     }
            //     return { data: { Success: false, Data: { Data: [], TotalCount: 0 } } };
            // })
            // .catch((err) => {
            //     this.$result(null, err);
            //     return { data: { Success: false, Data: { Data: [], TotalCount: 0 } } };
            // });
        },

        loadFilterData() {
            this.languagesLoading = true;
            WebsiteApi.Language.GetAll()
                .then((response) => {
                    if (response.data.Success) {
                        this.languages = response.data.Data || [];
                    }
                })
                .finally(() => {
                    this.languagesLoading = false;
                });

            this.navigationsLoading = true;
            WebsiteApi.Navigation.GetTree('main', 'tr')
                .then((response) => {
                    if (response.data.Success) {
                        const rawData = response.data.Data || [];
                        this.navigations = this.flattenNavigationsForSelect(rawData);
                    }
                })
                .finally(() => {
                    this.navigationsLoading = false;
                });
        },

        flattenNavigationsForSelect(items, result = []) {
            if (!items || !Array.isArray(items)) return result;
            items.forEach(item => {
                result.push({
                    Id: item.Id,
                    Title: this.getNavigationTitle(item),
                });
                if (item.ChildNavigations && item.ChildNavigations.length > 0) {
                    this.flattenNavigationsForSelect(item.ChildNavigations, result);
                }
            });
            return result;
        },

        getNavigationTitle(item) {
            if (!item.Translations || !Array.isArray(item.Translations)) {
                return item.NavigationKey || 'Başlıksız';
            }
            const translation = item.Translations.find(t => t.LanguageCode === this.filter.LanguageCode || 'tr');
            return translation?.Title || item.NavigationKey || 'Başlıksız';
        },

        loadParentContents() {
            if (this.parentContentsLoaded) return Promise.resolve();

            const payload = {
                LanguageCode: "tr",
                IncludeTranslations: true,
                Take: 100,
                Skip: 0,
            };

            return WebsiteApi.Content.GetContents(payload)
                .then((response) => {
                    if (response.data.Success) {
                        const raw = response.data.Data;
                        const list = Array.isArray(raw) ? raw : Array.isArray(raw && raw.Data) ? raw.Data : [];

                        this.parentContents = list.filter((c) => !c.ParentContentId);
                        this.parentContentsLoaded = true;
                    } else {
                        this.parentContents = [];
                    }
                })
                .catch((err) => {
                    this.parentContents = [];
                    this.$result && this.$result(null, err);
                });
        },

        clearForm() {
            this.editing = false;
            this.errors = {};
            this.editedItem = {
                id: null,
                navigationIds: [],
                parentContentId: null,
                contentKey: "",
                slug: "",
                isActive: true,
                isFeatured: false,
                publishDate: new Date().toISOString(),
                sortOrder: 0,
                translations: [],
                metaData: [],
                mediaFiles: [],
            };
        },

        createNew() {
            this.clearForm();
            this.modalVisible = true;
            this.$nextTick(() => {
                this.$bvModal.show("modal-content");
            });
        },

        edit(item) {
            this.clearForm();
            this.editing = true;

            WebsiteApi.Content.GetById(item.Id, this.filter.LanguageCode || "tr")
                .then((response) => {
                    if (response.data.Success && response.data.Data) {
                        const data = response.data.Data;
                        
                        // Transform Navigations array to navigationIds format
                        let navigationIds = [];
                        if (data.Navigations && Array.isArray(data.Navigations)) {
                            navigationIds = data.Navigations.map(nav => ({
                                navigationId: nav.NavigationId,
                                isPrimary: nav.IsPrimary || false,
                                sortOrder: nav.SortOrder || 0,
                                isActive: nav.IsActive !== undefined ? nav.IsActive : true
                            }));
                        }
                        
                        this.editedItem = {
                            id: data.Id,
                            navigationIds: navigationIds,
                            parentContentId: data.ParentContentId,
                            contentKey: data.ContentKey,
                            slug: data.Slug,
                            isActive: data.IsActive,
                            isFeatured: data.IsFeatured,
                            publishDate: data.PublishDate,
                            sortOrder: data.SortOrder,
                            translations: data.Translations || [],
                            metaData: data.MetaData || [],
                            mediaFiles: data.MediaFiles || [],
                        };
                        this.modalVisible = true;
                        this.$nextTick(() => {
                            this.$bvModal.show("modal-content");
                        });
                    } else {
                        this.$result(response);
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                });
        },

        onModalHidden(event) {
            if (event.componentId === "modal-content") {
                this.modalVisible = false;
            }
        },

        save() {
            this.errors = {};

            if (!this.editedItem.contentKey) {
                this.$set(this.errors, "contentKey", "Content Key zorunludur.");
                return;
            }
            if (!this.editedItem.slug) {
                this.$set(this.errors, "slug", "Slug zorunludur.");
                return;
            }

            // Transform navigationIds for backend
            const navigationIds = this.editedItem.navigationIds && this.editedItem.navigationIds.length > 0
                ? this.editedItem.navigationIds.map(n => ({
                    NavigationId: n.navigationId,
                    IsPrimary: n.isPrimary || false,
                    SortOrder: n.sortOrder || 0,
                    IsActive: n.isActive !== undefined ? n.isActive : true
                }))
                : [];

            const payload = {
                NavigationIds: navigationIds,
                ParentContentId: this.editedItem.parentContentId,
                ContentKey: this.editedItem.contentKey,
                Slug: this.editedItem.slug,
                IsActive: this.editedItem.isActive,
                IsFeatured: this.editedItem.isFeatured,
                PublishDate: this.editedItem.publishDate,
                SortOrder: this.editedItem.sortOrder,
                Translations: this.editedItem.translations,
                MetaData: this.editedItem.metaData,
                MediaFiles: this.editedItem.mediaFiles,
            };

            this.loading = true;

            const apiCall = this.editing ? WebsiteApi.Content.Update(this.editedItem.id, payload) : WebsiteApi.Content.Create(payload);

            apiCall
                .then((response) => {
                    if (response.data.Success) {
                        this.$refs.table.refresh();
                        this.$bvModal.hide("modal-content");
                        this.parentContentsLoaded = false;
                        this.loadParentContents();
                    } else if (response.data && response.data.errors) {
                        this.errors = response.data.errors;
                    }
                    this.$result(response);
                })
                .catch((err) => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.errors = err.response.data.errors;
                    }
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        deleteItem(item) {
            this.$confirm("İçeriği Sil", `"${item.Translations?.[0]?.Title || item.ContentKey}" içeriğini silmek istediğinize emin misiniz? Bu işlem geri alınamaz.`).then((result) => {
                if (result) {
                    WebsiteApi.Content.Delete(item.Id)
                        .then((response) => {
                            if (response.data.Success) {
                                this.$refs.table.refresh();
                                this.parentContentsLoaded = false;
                                this.loadParentContents();
                            }
                            this.$result(response);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
        showPreview(item) {
            this.previewItem = item;
            this.$bvModal.show("modal-content-preview");
        },
    },
};
</script>
